import React, { useState, useEffect } from 'react';
import {
    FormControl,
    FormLabel,
    Select,
    Skeleton,
    Alert,
    AlertIcon,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { useAuth } from '../contexts/AuthContext';
import { fetchWithAuth } from '../utils/fetchWithAuth';


const SystemPromptSelector = ({ systemPrompt, setSystemPrompt }) => {
    const [systemPrompts, setSystemPrompts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const { user } = useAuth();

    useEffect(() => {
        if (!user) {
            setIsLoading(false);
            return;
        }

        const fetchSystemPrompts = async () => {
            try {
                const response = await fetchWithAuth('/api/system-prompts', {
                });
                
                if (!response.ok) {
                    throw new Error('Failed to fetch system prompts');
                }
                
                const data = await response.json();
                setSystemPrompts(data);
                setError(null);
            } catch (error) {
                console.error('Error fetching system prompts:', error);
                setError('Failed to load system prompts');
            } finally {
                setIsLoading(false);
            }
        };

        fetchSystemPrompts();
    }, [user]);

    const handleChange = (e) => {
        setSystemPrompt(e.target.value);
    };

    if (isLoading) {
        return (
            <FormControl>
                <FormLabel fontSize="sm" color="text.primary">
                    System:
                </FormLabel>
                <Skeleton height="40px" borderRadius="md" />
            </FormControl>
        );
    }

    if (error) {
        return (
            <FormControl>
                <FormLabel fontSize="sm" color="text.primary">
                    System:
                </FormLabel>
                <Alert status="error" size="sm" borderRadius="md">
                    <AlertIcon />
                    Error loading prompts
                </Alert>
            </FormControl>
        );
    }

    return (
        <FormControl>
            <Select
                value={systemPrompt}
                variant="messageInput"
                onChange={handleChange}
                bg="bg.primary"
                border="1px"
                borderColor="border.primary"
                _hover={{ borderColor: "border.secondary" }}
                _focus={{
                    borderColor: "brand.500"
                }}
                fontSize={{ base: 'md', md: 'sm' }}
                size="sm"
                transitionProperty="common"
                transitionDuration="normal"
            >
                {systemPrompts.map((prompt) => (
                    <option key={prompt.value} value={prompt.value}>
                        {prompt.label}
                    </option>
                ))}
            </Select>
        </FormControl>
    );
};

SystemPromptSelector.propTypes = {
    systemPrompt: PropTypes.string.isRequired,
    setSystemPrompt: PropTypes.func.isRequired,
};

export default SystemPromptSelector;